import React from "react";
import FlexBox from "design-system/src/Components/FlexBox/FlexBox";
import Typography from "design-system/src/Foundation/Typography/Typography";
import { useTranslation } from "@src/hooks/useTranslation";
import Button from "design-system/src/Foundation/Button/Button";
import { _AccountOrderButtonWrapper } from "../GameParticipationModal.styled";

interface IParticipationConfirmationProps {
  onOk?: () => void;
}

const ParticipationConfirmation = (props: IParticipationConfirmationProps) => {
  const { onOk } = props;
  const { t } = useTranslation(["Pacman"]);

  return (
    <FlexBox direction="column" align="center" style={{ textAlign: "center" }}>
      <FlexBox
        direction="column"
        className="text-container"
        align="center"
        gap={24}
      >
        <svg
          width="57"
          height="57"
          viewBox="0 0 57 57"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ marginBottom: 16 }}
        >
          <circle
            cx="28.5"
            cy="28.5"
            r="27"
            stroke="#0BC264"
            stroke-width="2"
          />
          <path
            d="M17.5 29.5L24.5 36.5L42.5 18.5"
            stroke="#0BC264"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>

        <FlexBox direction="column" gap={16}>
          <Typography variant="h7">
            {t("Merci pour votre participation !", "Pacman")}
          </Typography>
          <Typography variant="body">
            {t(
              "Nous vous informerons par mail si vous êtes tiré.e au sort.",
              "Pacman"
            )}
          </Typography>
          <Typography variant="subtitle3" color={"greyText2"}>
            {t(
              "En attendant, si vous souhaitez participer à d'autres jeux-concours, abonnez-vous à nos newsletters et recevez par e-mail nos derniers jeux-concours, nos nouveautés à la carte et plus encore.",
              "Pacman"
            )}
          </Typography>
        </FlexBox>
      </FlexBox>

      <_AccountOrderButtonWrapper mt={24}>
        <Button
          style={{ position: "relative" }}
          type="submit"
          color={"primary"}
          onClick={onOk}
        >
          {t("Retourner à la carte", "Pacman")}
        </Button>
      </_AccountOrderButtonWrapper>
    </FlexBox>
  );
};

export default ParticipationConfirmation;
